// ---------------------------------------------------------------------------
// Status Bar — bottom bar showing flow info, node/connection counts, zoom.
// All visual constants from design-tokens.ts.
// ---------------------------------------------------------------------------

import { useFlowEditorStore } from '@/features/flow-editor/store/flow-editor-store'
import { STATUS_BAR } from '@/features/flow-editor/lib/design-tokens'

export function StatusBar() {
  const flows = useFlowEditorStore((s) => s.flows)
  const selectedFlowId = useFlowEditorStore((s) => s.selectedFlowId)
  const nodes = useFlowEditorStore((s) => s.nodes)
  const connections = useFlowEditorStore((s) => s.connections)
  const selectedNodeIds = useFlowEditorStore((s) => s.selectedNodeIds)

  const currentFlow = flows.find((f) => f.id === selectedFlowId)

  return (
    <div className={STATUS_BAR.containerClass}>
      {currentFlow && (
        <span>
          {currentFlow.name} ({currentFlow.trigger})
        </span>
      )}
      <span>{nodes.length} nodes</span>
      <span>{connections.length} connections</span>
      {selectedNodeIds.length > 0 && (
        <span>{selectedNodeIds.length} selected</span>
      )}
      <div className="flex-1" />
      <span>ActionFlow Editor</span>
    </div>
  )
}
